<template>
<div class="menuBody" >
   <projectTree @AllData="getMsgFormSon" @NodeData="NodeData" />
        <InvoiceItemDialog :param="diaLogData" @reset="reset" ref="InvoiceItemDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
            <div style="border-bottom:1px solid rgba(234, 237, 241, 1);width:100%;height:30px;margin-bottom:10px">
                开票项目列表  
                <div style="float:right;margin-top:-5px;margin-right:10px">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:invoiceItem:save'"  @click="PropertyAdd()">开票项目添加</el-button>
            </div>
            <div style="float:right;margin-top:-5px;margin-right:10px" >
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:invoiceItem:addTaxControl'"  @click="DownCourseAdd()">应用到其他项目</el-button>
            </div>
            </div>
            <div style="width:170px;float:left;margin-right:30px">
                <el-select  clearable v-model="value" placeholder="请选择收费项目" @change="expend()"  size="small" >
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="width:170px;float:left;margin-right:30px">
                <el-cascader
                size="small"
                placeholder="请选择应税科目"
                :options="amount"
                v-model="amountval"
                :props="{ checkStrictly: true }"
                :show-all-levels="false"
                @change="AmountChange"
                clearable></el-cascader>
            </div>
            <div style="float:left;">
                <el-button type="primary" size="small" plain  style="background: #246CE5;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cs:invoiceItem:selectListPage'" @click="Inquire()">查询</el-button>
            </div>

  <el-table  :data="tableData "  v-loading="loading"
  @selection-change="handleSelectionChange"    
  style="overflow-y: scroll;float:right;margin-top:30px" row-key="id"  tooltip-effect="light" 
    :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeitemName" label="收费项目"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="ext3" label="显示名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="subjectsName" label="应税科目" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="taxRate" label="税率 %" ></el-table-column>
    <el-table-column fixed="right" label="操作" >
     <template slot-scope="scope">
          <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small" title="修改" v-Jurisdiction="'expense:web:cs:invoiceItem:save'" ></el-button>
          <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small" title="删除" v-Jurisdiction="'expense:web:cs:invoiceItem:delete'" v-debounce></el-button>
        </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import InvoiceItemDialog from "../common/InvoiceItemDialog";
import projectTree from "../common/projectTree.vue";

export default {
  name: "InvoiceItem",
  components: {InvoiceItemDialog,projectTree},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        CourseCode:"",
        CourseName:"",
        UpCourseCode:"",
        amount:[],
        amountval:"",
      tableData: [],
      options: [{
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      USERObj:"",
      ProjectMana:"",
      taxRateval:"",
      taxRatelab:"",
      grounp:"",
      openArr:[],
    }
  },
  methods: {
    AmountChange(){
      var arr = this.amountval
      var ende = arr[arr.length-1]
      for(let val of this.amount){
        if(this.amountval == val.value){
          this.taxRateval = val.value
          this.taxRatelab = val.label
        }else{
          var end = arr[0]
          if(end == val.value){
            for(let arr of val.children){
              if(ende == arr.value){
                  this.taxRateval = arr.value
                  this.taxRatelab = arr.label
              }
            }
          }
        }
      }
      // console.log(this.taxRateval)
    },
    expend(){
      // console.log(this.value)
    },
    reset(data){
      if(data.reset == false){
        this.loading = true
        this.getAllMenu()
      }
    },
    handleSelectionChange(res){
      this.USERObj = res
      let arr = []
      for(let val of res){
        arr.push(val.id)
      }
      this.openArr = arr
    },
    getMsgFormSon(data){
      this.AllData = data
    },
    NodeData(data){
      this.loading = true
      this.grounp = data.value
      this.getAllMenu()
    },
     handleSizeChange(val) {
        this.loading = true
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.loading = true
        this.currentPage = val
        this.getAllMenu()
    },
    Inquire(){
        // 查询
         let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "feeitemCode":this.value,
        "subjectsCode":this.taxRateval,
        "projectId":this.grounp
      }
        this.$http.post(this.$requestUrl.POST_INVOICE_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
                this.total = data.data.total
            this.tableData = data.data.records;
          } else {
            this.$message.error(result.msg)
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "projectId":this.grounp
      }
        this.$http.post(this.$requestUrl.POST_INVOICE_LIST,PageSize).then((res) => {
          let data = res.data;
           
          if (200 === data.code) {
             this.total = data.data.total
            this.tableData = data.data.records;
            for(let val of data.data.records) {
                this.traverse(val)
            }
              this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
          this.loading = false
        })
      },

      traverse(res){
        for(let val of this.options){
          if(res.subjectsCode == val.subjectsCode){
            res.subjectsName = val.subjectsName
          }
        }
      },
    PropertyAdd(){
        // 添加项目
        if(this.USERObj.length == 0){
            this.$refs.InvoiceItemDialog.title = "添加";
      this.$refs.InvoiceItemDialog.dialogVisible = true; 
      this.$refs.InvoiceItemDialog.ifelse = false;
      this.$refs.InvoiceItemDialog.options = this.options
      this.$refs.InvoiceItemDialog.projectId = this.grounp
      this.$refs.InvoiceItemDialog.value = ""
      this.$refs.InvoiceItemDialog.displayName = ""


          let obj = {
            "feeitemName":"收费项目",
            "displayName":"显示名称",
            "subjectsName":"应税科目",
            "taxRate":"税率",
            "remark":"备注信息",
          }
          let row = {}
          row.obj = obj
 
         this.$refs.InvoiceItemDialog.formLabelAlign= row;
        }
    },
    editMenu(row) { // 修改
    // console.log(row)
      this.$refs.InvoiceItemDialog.title = "修改";
      this.$refs.InvoiceItemDialog.dialogVisible = true;
       this.$refs.InvoiceItemDialog.ifelse = false;
      this.$refs.InvoiceItemDialog.options = this.options
      this.$refs.InvoiceItemDialog.projectId = this.grounp
            let obj = {
            "feeitemName":"收费项目",
            "displayName":"显示名称",
            "subjectsName":"应税科目",
            "taxRate":"税率",
            "remark":"备注信息",
          }
        row.obj = obj
        this.$refs.InvoiceItemDialog.value = row.feeitemCode
        this.$refs.InvoiceItemDialog.displayName = row.feeitemName
         this.$refs.InvoiceItemDialog.formLabelAlign= row;
        },
        DownCourseAdd(){
           // 应用到其他科目
           if(this.USERObj.length <1){
              this.$message({
            type: "warning",
            message: "请选择一条科目信息"
          })
          }else{
            this.$refs.InvoiceItemDialog.title = "应用到其他科目";
 this.$refs.InvoiceItemDialog.dialogVisible = true; 
      this.$refs.InvoiceItemDialog.ifelse = true;
      this.$refs.InvoiceItemDialog.options = this.AllData
       this.$refs.InvoiceItemDialog.taxIds = this.openArr
          }
        },
        delMenu(row){
   this.$confirm('是否确认要删除该项目?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
    this.$http.post(this.$requestUrl.POST_DELETE_INVOICE+"?id="+row.id).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.loading = true
          this.getAllMenu()
             this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else{
           this.$message({
            type: 'warning',
            message: '删除失败'
          });
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });

      
    },
     RevenueType(){
          this.$http.get(this.$requestUrl.GET_CHARGE_LIST).then((res)=>{
           let result = res.data;
        if (200 === result.code) {
          this.RevenueTypeone(result.data)
        }
        })
    },
    RevenueTypeone(params){
       var result = [];
                for (let val of params) {
 
                  if(val.parentCode == null || val.parentCode == ""){
                    var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    parent.children = this.RevenueTypeTwo(val.subjectsCode,params)
                    result.push(parent);
                  }
                  if(val.parentCode == "0"){
                     var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    result.push(parent)
                  }
                  if(val.parentCode == "1"){

                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    result.push(parent)
                  }
                  if(val.parentCode == "600110"){  
                          var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }
                    result.push(parent)
                  }
                  if(val.parentCode == "29290"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
                  if(val.parentCode == "10802"){
                        var parent = {
                      "label":val.subjectsName,
                      "value":val.subjectsCode,
                      type:val.parentCode
                    }

                    result.push(parent)
                  }
 
                  this.amount = result
    }
  },
      RevenueTypeTwo(id,array){
        let childs = new Array();
        for(let arr of array){
          if (arr.parentCode == id) {
           childs.push({
               'label': arr.subjectsName,
               'value': arr.subjectsCode,
               'type':arr.parentCode,
           });
          }
        }
         return childs;
    },
    ItemWeight(){
          this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
           let result = res.data;
           let arr = []
           for(let val of result.data){
            //  console.log(val)
               let obj = {
                   "value":val.feeCode,
                   "label":val.feeName,
                   "type":val.id,
                   "subjectsCode":val.subjectsCode,
                   "subjectsName":val.subjectsName,
                   "displayName":val.displayName,
               }
               arr.push(obj)
           }
           this.options = arr
        })
    },

  },
  mounted() {
      this.ItemWeight();
      this.RevenueType();
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;
    }
  }

}
</style>